import { z } from "zod";

import { zOutSchema } from "./common";

import { Response } from "~/shared/api";

const zRes = Response.Schema.zSuccessful(200, z.array(zOutSchema));
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
